module.exports = __webpack_public_path__ + "img/pool-no.84f6c648.svg";